import TextInput from "./Input/TextInput";
import DefaultButton from "./Button/DefaultButton.vue";

export default [
    TextInput,
    DefaultButton
]